import React from 'react';

function TableCheckBoxTemplate({ dataItem, field, onClick }) {
	const colProps = {},
		colName = dataItem.id + '_' + field;
	if (onClick) {
		colProps.onClick = () => onClick({ dataItem, field });
	}
	return (
		<td key={field} colSpan="1">
			<input
				{...colProps}
				className="input--toggle"
				type="checkbox"
				id={colName}
				value="1"
				checked={dataItem[field]}
				readOnly={true}
			/>
			<label htmlFor={colName}>&nbsp;</label>
		</td>
	);
}

export default TableCheckBoxTemplate;



// WEBPACK FOOTER //
// ./src/themes/default/components/table/TableCheckBoxTemplate.jsx